module.exports = __webpack_public_path__ + "img/active_2.47e54e64.png";